<template>
  <TopBarVue @go-section="goToSection" />

  <section ref="home" id="home" class="home nav-class">
    <LandingBlockVue />
  </section>

  <section ref="about" id="about" class="about nav-class">
    <AboutBlockVue />
  </section>

  <section ref="resume" id="resume" class="resume nav-class">
    <ResumeVue />
  </section>

  <section ref="projects" id="projects" class="projects nav-class">
    <ProjectsVue />
  </section>

  <section ref="contact" id="contact" class="contact nav-class">
    <ContactVue />
  </section>

  <section ref="footer" class="footer nav-class">
    <FooterVue />
  </section>
</template>

<script>
import TopBarVue from "./components/TopBar.vue";
import LandingBlockVue from "./components/LandingBlock.vue";
import AboutBlockVue from "./components/AboutBlock.vue";
import ResumeVue from "./components/Resume.vue";
import ContactVue from "./components/Contact.vue";
import ProjectsVue from "./components/Projects.vue";
import FooterVue from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    TopBarVue,
    LandingBlockVue,
    AboutBlockVue,
    ResumeVue,
    ContactVue,
    ProjectsVue,
    FooterVue,
  },
  methods: {
    goToSection(sectionRef) {
      const element = this.$refs[sectionRef];
      if (element) {
        window.scrollTo({
          top: element.offsetTop,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Poppins', sans-serif;
  scroll-behavior: smooth;
}

html, body {
  width: 100%;
  overflow-x: hidden; /* ✅ final fix — removes horizontal scroll */
}

body {
  font-size: 1rem;
}

/* Sections */
section {
  width: 100%;
  overflow-x: hidden;
}

.home {
  height: 100vh;
  background: linear-gradient(to left, #ffffff 50%, #ecf0ff 50%);
  background-position: center top;
  background-size: cover;
}

.about, .resume, .projects, .contact, .footer {
  width: 100%;
  background-position: center top;
  background-size: cover;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #888;
}
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
